var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"1200px","width":"100%"}},[_c('canvas',{ref:"chartCanvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }